import React from "react";
import "./App.css";
class Footer extends React.Component {
  render() {
    return (
      <div className="footer">
        <h3>© 2020 Vow'd, Inc. All rights reserved. </h3>
        <h5>Privacy · Terms · Sitemap</h5>
      </div>
    );
  }
}
export default Footer;
